import { PortalType } from "@studyportals/domain-client";
import { ROUTE_PREFIX } from '@generator/config/route-prefix';

// Base paths for each portal type, prefixed based on runtime env
export const programmePortalTypeBasePaths: Record<string, string> = {
	[PortalType.MASTER]: `${ROUTE_PREFIX}/search/master`,
	[PortalType.BACHELOR]: `${ROUTE_PREFIX}/search/bachelor`,
	[PortalType.PHD]: `${ROUTE_PREFIX}/search/phd`,
	[PortalType.DISTANCE_LEARNING]: `${ROUTE_PREFIX}/search/distance-learning`,
	[PortalType.SHORT]: `${ROUTE_PREFIX}/search/course`
}

// Base paths for each portal type, prefixed based on runtime env
export const universityPortalTypeBasePaths: Record<string, string> = {
	[PortalType.MASTER]: `${ROUTE_PREFIX}/search/universities/master`,
	[PortalType.BACHELOR]: `${ROUTE_PREFIX}/search/universities/bachelor`,
	[PortalType.PHD]: `${ROUTE_PREFIX}/search/universities/phd`,
	[PortalType.DISTANCE_LEARNING]: `${ROUTE_PREFIX}/search/universities/distance-learning`,
	[PortalType.SHORT]: `${ROUTE_PREFIX}/search/universities/course`
}

// Scholarship search is only served by OmniSearch under the route prefix (test environment);
// without a prefix scholarship URLs keep going to the legacy ScholarshipsSearch page
export const isPrefixedScholarshipPath = (path: string): boolean => {
	const prefix: string = ROUTE_PREFIX;

	return prefix !== '' && path.startsWith(`${prefix}/search/scholarships`);
};